import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const sideDialogStyleId = 'wb-v2-side-dialog-theme';

export const sideDialogBridgeStyles = {
  'wb-side-dialog': {
    '--local-side-dialog-bg': tokens.color.background.primary,
    '--local-side-dialog-border': tokens.color.border.secondary,
    '--local-side-dialog-shadow': tokens.shadow.lg,
    '--local-side-dialog-width': '440px',
    '--local-side-dialog-z-index': '1001',
    '--local-side-dialog-slide-in-duration': '0.25s',
    '--local-side-dialog-slide-in-easing': 'cubic-bezier(0.16, 1, 0.3, 1)',
    '--local-side-dialog-slide-out-duration': '0.2s',
    '--local-side-dialog-slide-out-easing': 'cubic-bezier(0.4, 0, 0.2, 1)',
    '--local-side-dialog-push-radius': tokens.radius.lg,
  },
};
